export default "__VITE_ASSET__1e4a5e05__"